<fieldset *ngIf="orderSummary$ | async as summary">
  <table
    [attr.data-e2e]="'order:summary'"
    [orderformBreakpoint]="{ '960': 'table-small-view' }"
    orderformBreakpointOperator=">"
  >
    <tr class="total-row" *ngIf="summary.shipping_total_undiscounted.first.net > 0">
      <td class="value-label" [ngSwitch]="!!summary.shipping_cost_label">
        <ng-container i18n="@@order_summary.shipping_total" *ngSwitchCase="false">Porto & Verpackung</ng-container>
        <ng-container *ngSwitchCase="true">{{ summary.shipping_cost_label }}</ng-container>
      </td>
      <td class="value">
        <s
          class="d-block text-muted"
          [attr.data-e2e]="'order:summary:shipping_total:undiscounted'"
          *ngIf="
            (showDiscountOnSummary$ | async) &&
            summary.shipping_total.first.net !== summary.shipping_total_undiscounted.first.net &&
            summary.shipping_total_undiscounted.first as undiscounted
          "
          >{{ undiscounted | price }}</s
        >
        <span [attr.data-e2e]="'order:summary:shipping_total'">{{ summary.shipping_total.first | price }}</span>
      </td>
    </tr>

    <tr class="total-row" *ngIf="(isVatShown$ | async) && (productsLength$ | async) > 1">
      <td class="value-label" i18n="@@order_summary.sub_total"> Zwischensumme </td>
      <td class="value" *ngIf="summary.order_total.first.net | price as price">
        <s
          class="d-block text-muted"
          [attr.data-e2e]="'order:summary:order_total_net:undiscounted'"
          *ngIf="
            (showDiscountOnSummary$ | async) &&
            summary.order_total.first.net !== summary.order_total_undiscounted.first.net &&
            summary.order_total_undiscounted.first.net as undiscounted
          "
        >
          {{ undiscounted | price }}
        </s>
        <span [attr.data-e2e]="'order:summary:order_total_net'">{{ price }}</span>
      </td>
    </tr>

    <ng-container *ngIf="isVatShown$ | async">
      <tr class="total-row" *ngFor="let vat of summary.vat_amounts">
        <td class="value-label" [attr.data-e2e]="'order:summary:vat_percent'">{{ vat.label }}</td>
        <td class="value" [attr.data-e2e]="'order:summary:vat_amount'">{{ vat.vat_1st | price }}</td>
      </tr>
    </ng-container>

    <tr class="total-row total-row-final">
      <td class="value-label">
        <span [class.text-bold]="!summary.order_final.is_shown" i18n="@@order_summary.order_total">Summe</span>
      </td>
      <td class="value value-total" *ngIf="summary.order_total.first.gross | price as price">
        <s
          class="d-block text-muted"
          *ngIf="
            (showDiscountOnSummary$ | async) &&
            price !== (summary.order_total_undiscounted.first.gross | price) &&
            (summary.order_total_undiscounted.first.gross | price) as undiscountedPrice
          "
          [attr.data-e2e]="'order:summary:order_total:undiscounted'"
          >{{ undiscountedPrice }}</s
        >
        <span [attr.data-e2e]="'order:summary:order_total'">{{ price }}</span>
      </td>
    </tr>

    <ng-container *ngIf="summary.order_final.is_shown">
      <tr
        class="total-row total-row-final"
        *ngFor="let discount of summary.brutto_discounts"
        [attr.data-e2e]="'order:summary:discount'"
      >
        <td class="value-label text-bold">{{ discount.reason_html }}</td>
        <td class="value">{{ discount.amount | price }}</td>
      </tr>
      <tr class="total-row">
        <td class="value-label text-bold" i18n="@order-summary.label.payment_amount">Zahlbetrag </td>
        <td class="value" [attr.data-e2e]="'order:summary:order_final'">{{ summary.order_final.gross_1st | price }}</td>
      </tr>
    </ng-container>
  </table>

  <div [orderformBreakpoint]="{ '850': 'summary-info-max-width' }" orderformBreakpointOperator=">">
    <div class="summary-info-size">
      <div
        [attr.data-e2e]="'order:summary:info:vat_included'"
        *ngIf="
          (havePlainPriceView$ | async) === false &&
          (isVatShown$ | async) === false &&
          (isVatHintMandatory$ | async) === true
        "
        class="text-right mb-3"
        i18n="@@order_summary.vat_included"
      >
        Einschließlich Mehrwertsteuer
      </div>
      <div *ngIf="summary.footnote as note" class="text-right mb-3" [attr.data-e2e]="'order:summary:info:footnote'">
        <div class="d-inline" [innerHTML]="note | sanitize : 'HTML'"><!-- Do not use span... style issues...--></div>
      </div>
    </div>
  </div>

  <p-dialog
    *ngIf="summary.plan_info_tooltip.is_shown"
    [header]="summary.plan_info_tooltip.label"
    [(visible)]="footerInfoDialogVisible"
    [dismissableMask]="true"
    [draggable]="false"
    [modal]="true"
    [attr.data-e2e]="'order:summary:info:plan_tooltip'"
  >
    <iframe
      title="Payment plan info"
      class="plan_info_tooltip"
      [src]="summary.plan_info_tooltip.tooltip_contents_url | sanitize : 'RESOURCE_URL'"
    ></iframe>
    <p-footer>
      <button class="ds-button primary" (click)="footerInfoDialogVisible = false" i18n="@@common.button.close"
        >Schließen
      </button>
    </p-footer>
  </p-dialog>
</fieldset>
